// components/TransfertTitres/TransferSecurityForm.jsx
import { Upload, AlertCircle } from 'lucide-react';
import SearchableSelect from '../../../SearchableSelect';

const TransferSecurityForm = ({
  formData,
  errors,
  isLoading,
  securities,
  onFieldChange,
  operationType = 'add', // 'add' ou 'remove'
  accountDisplayName = '',
}) => {
  const isAdd = operationType === 'add';

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Vérifier la taille (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        onFieldChange('preuveError', 'Le fichier ne doit pas dépasser 5MB');
        return;
      }
      
      // Vérifier le type
      const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        onFieldChange('preuveError', 'Format de fichier non supporté (JPEG, PNG, GIF, PDF uniquement)');
        return;
      }
      
      onFieldChange('preuve', file);
    }
  };

  return (
    <div className="transfer-security-form">
      <div className="mb-4 p-3 bg-info bg-opacity-10 rounded">
        <p className="mb-0 text-info">
          <strong>Compte:</strong> {accountDisplayName}
        </p>
        <p className="mb-0 text-info">
          <strong>Opération:</strong> {isAdd ? 'Ajout de titres' : 'Retrait de titres'}
        </p>
      </div>

      {/* Sélection du titre */}
      <div className="mb-4">
        <label className="form-label fw-semibold">
          Sélectionner le titre <span className="text-danger">*</span>
        </label>
        <SearchableSelect
          options={securities}
          value={securities.find(s => s.value === formData.securityId)}
          onChange={(selected) => onFieldChange('securityId', selected?.value || '')}
          placeholder="Rechercher un titre..."
          isDisabled={isLoading}
          searchKeys={['label']}
          noOptionsMessage="Aucun titre trouvé"
          className={errors.securityId ? 'is-invalid' : ''}
        />
        {errors.securityId && (
          <div className="invalid-feedback d-flex align-items-center mt-1">
            <AlertCircle size={14} className="me-1" />
            {errors.securityId}
          </div>
        )}
      </div>

      {/* Quantité */}
      <div className="mb-4">
        <label className="form-label fw-semibold">
          Quantité <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            type="number"
            className={`form-control ${errors.quantity ? 'is-invalid' : ''}`}
            value={formData.quantity}
            onChange={(e) => onFieldChange('quantity', e.target.value)}
            min="1"
            step="1"
            disabled={isLoading}
            placeholder="Entrez la quantité"
          />
          <span className="input-group-text">unités</span>
        </div>
        {errors.quantity && (
          <div className="invalid-feedback d-flex align-items-center mt-1">
            <AlertCircle size={14} className="me-1" />
            {errors.quantity}
          </div>
        )}
      </div>

      {/* Upload de preuve */}
      <div className="mb-4">
        <label className="form-label fw-semibold">
          Preuve de transaction <span className="text-danger">*</span>
          <small className="text-muted ms-2">(JPEG, PNG, GIF, PDF - max 5MB)</small>
        </label>
        
        <div className={`file-upload-container ${errors.preuve ? 'is-invalid' : ''}`}>
          <input
            type="file"
            id="preuve-upload"
            className="d-none"
            onChange={handleFileChange}
            accept=".jpg,.jpeg,.png,.gif,.pdf"
            disabled={isLoading}
          />
          
          <label htmlFor="preuve-upload" className="file-upload-label">
            <Upload size={18} className="me-2" />
            {formData.preuve ? formData.preuve.name : 'Choisir un fichier'}
          </label>
        </div>
        
        {formData.preuve && (
          <div className="mt-2">
            <small className="text-muted">
              Fichier sélectionné: {formData.preuve.name} 
              ({Math.round(formData.preuve.size / 1024)} KB)
            </small>
          </div>
        )}
        
        {errors.preuve && (
          <div className="invalid-feedback d-flex align-items-center mt-1">
            <AlertCircle size={14} className="me-1" />
            {errors.preuve}
          </div>
        )}
      </div>

      {/* Instructions */}
      <div className="alert alert-info mb-4">
        <div className="d-flex">
          <AlertCircle size={16} className="me-2 flex-shrink-0 mt-1" />
          <div>
            <small>
              <strong>Note importante:</strong> La preuve de transaction est obligatoire pour 
              {isAdd ? " l'ajout" : " le retrait"} de titres. Assurez-vous que le document est 
              clairement lisible.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferSecurityForm;